import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2, Lock } from "lucide-react";
import { TextField } from "@/components/admin/Field";

export default function AdminLogin() {
  const { login, user, ready } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (ready && user) navigate("/admin", { replace: true });
  }, [ready, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin", { replace: true });
    else setError(res.error);
  };

  return (
    <div className="min-h-screen grid place-items-center bg-stone-100 px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="mx-auto grid place-items-center h-14 w-14 rounded-full bg-stone-950 text-stone-50 mb-5">
            <Lock className="h-6 w-6" />
          </div>
          <h1 className="font-serif text-3xl text-stone-900">Painel de Administração</h1>
          <p className="text-sm text-stone-500 mt-2">Acesse para editar o conteúdo do site.</p>
        </div>

        <form
          onSubmit={submit}
          data-testid="admin-login-form"
          className="rounded-lg border border-stone-200 bg-white shadow-sm p-8 space-y-5"
        >
          <TextField
            label="E-mail"
            type="email"
            value={email}
            onChange={setEmail}
            testid="admin-login-email"
            placeholder="admin@restaurante.com"
          />
          <TextField
            label="Senha"
            type="password"
            value={password}
            onChange={setPassword}
            testid="admin-login-password"
            placeholder="••••••••"
          />
          {error && (
            <p data-testid="admin-login-error" className="text-sm text-red-600">
              {error}
            </p>
          )}
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 rounded-md bg-stone-950 text-stone-50 py-3 font-medium hover:bg-stone-800 transition-colors duration-300 disabled:opacity-50"
          >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}
            Entrar
          </button>
        </form>
      </div>
    </div>
  );
}
